module.exports = __webpack_public_path__ + "static/media/ponee.790c0daa.png";